import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { matchPath, withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import get from 'lodash/get'
import asset from 'utils/asset'
import { selectIsCateringFlowByVenueId } from 'store/catering-order-details/selectors'
import { Footer, FooterContent, Logo, Title } from './styled'

const PageFooter = ({ isCateringMenu }) => (
  <Footer background={isCateringMenu ? '#ffffff' : undefined}>
    <FooterContent>
      <Title>Ordering powered by</Title>
      <a
        href="https://heyyou.com.au/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Logo src={asset('icons/heyyou-logo-grey.svg')} />
      </a>
    </FooterContent>
  </Footer>
)

PageFooter.propTypes = {
  isCateringMenu: PropTypes.bool,
}

// White under a catering venue's menu, grey everywhere else.
const mapStateToProps = (state, { location }) => {
  const match = matchPath(get(location, 'pathname', ''), {
    path: '/restaurant/:id',
  })
  return {
    isCateringMenu:
      !!match && selectIsCateringFlowByVenueId(state, match.params.id),
  }
}

export const BasePageFooter = PageFooter
export default compose(withRouter, connect(mapStateToProps))(PageFooter)
